"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../ui");
var _index = require("../index");
var _ticker = require("../../ticker");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TertiaryShadeText = (0, _styledComponents.default)(_ui.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
var Item = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var Card = function Card(_ref2) {
  var transaction = _ref2.transaction,
    fiatWithdraw = _ref2.fiatWithdraw;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libTransactionsTable']),
    t = _useTranslation.t;
  if (transaction.target) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Item, {
      className: "mb-4"
    }, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:headers.details')), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
      value: transaction.amount.value,
      ticker: transaction.ticker
    }), ' ', transaction.ticker)), /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:id')), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_index.TransactionsTruncate, null, transaction.id))));
  }
  if (fiatWithdraw && transaction.betweenAccounts) {
    return /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:id')), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_index.TransactionsTruncate, null, transaction.id)));
  }
  if (fiatWithdraw) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      className: "mb-4"
    }, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransfers:to'), ":"), /*#__PURE__*/_react.default.createElement("div", null, transaction.to));
  }
  if (transaction.hash && transaction.blockchain) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      className: "mb-4"
    }, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:hash'), ":"), /*#__PURE__*/_react.default.createElement(_index.TransactionsCryptoTooltip, {
      hash: transaction.hash,
      blockchain: transaction.blockchain,
      className: "justify-content-end"
    }, /*#__PURE__*/_react.default.createElement(_index.TransactionsTruncate, null, transaction.hash)));
  }
  if (transaction.invoiceId) {
    return /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransaction:details.invoice')), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_index.TransactionsTruncate, null, transaction.invoiceId)));
  }
  return /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, t('libTransactionsTable:id')), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_index.TransactionsTruncate, null, transaction.id)));
};
exports.Card = Card;